var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center my-6"},[_c('a',{staticClass:"text-2xl text-primary-default underline",attrs:{"href":_vm.block.file.filename}},[_vm._v(_vm._s(_vm.block.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }